export const all_routes = {
  dashboard: "/admin-dashboard",
  productlist: "/products/*",
  productListTab: "/products/list",
  productOrdersTab: "/products/orders",
  productOrdersSummaryTab: "/products/orders-summary",
  productDeliverySummaryTab: "/products/delivery-summary",
  productStockEvolutionTab: "/products/stock-evolution",
  productStocksTab: "/products/stocks",
  productAddTab: "/products/add-product",
  productEditTab: "/products/edit-product/:productId/:variationId/:warehouseId",
  productViewTab: "/products/view-product/:productId/:variationId/:warehouseId",
  orderlist: "/order-list/*",
  supliersList: "/suppliers",
  warehousesList: "/warehouses",
  marketinglist: "/marketing/*",
  marketingFileValidator: "/marketing/file-validator",
  editmarketing: "/edit-marketing/:id?",
  offerpricinglist: "/offer-pricing-skus",
  mediaPlansList: "/media-plans/campaigns",
  mediaplans: "/media-plans",
  mediaPlansCampaign: "/media-plans/campaign/:mode/:clientId/:mediaPlanId?",
  mediaPlanPlanning: "/media-plans/planning",
  mediaPlanPurchaseOrderEvolution: "/media-plans/purchase-order-evolution",
  mediaPlanRor100Days: "/media-plans/ror-100-days",
  mediaPlanLists: "/media-plans/lists",
  mediaPlanCosts: "/media-plans/costs",
  costs: "/costs",
  estimatedCashFlow: "/estimated-cash-flow",
  customerReports: "/customer-reports",
  editMediaPlan: "/edit-media-plan",
  mediaPlansViewByCode: "/media-plans/view/:mediaPlanId",
  printList: "/print-list",
  settings: "/settings",
  clients: "/settings/clients",
  accessControl: "/access-control",
  letterProcessing: "/letter-processing",
  loginHistory: "/settings/login-history",
  addClient: "/settings/add-client",
  editClientTab: "/settings/edit-client",
  editclient: "/settings/edit-client",
  envelopelist: "/envelope-list",
  phoneNumbers: "/phone-numbers",
  editcallcenter: "/edit-call-center",
  mailingReport: "/mailing-report",
  lists: "/lists",
  salesByDate: "/sales-by-date",
  stockData: "/stock-data",
  mailingResponseLTVData: "/mailing-response-ltv-data",
  salesDumpData: "/sales-dump-data",
  salesDumpAnalysis: "/sales-dump-analysis",
  data: "/data/*",
  dataSalesReport: "/data/sales-report",
  dataSublyticsOrders: "/data/sublytics-orders",
  dataWordpressOrders: "/data/wordpress-orders",
  dataTigerTechOrders: "/data/tigertech-orders",
  dataSocrateOrders: "/data/socrate-orders",
  dataAuthorizeTransactions: "/data/authorize-transactions",
  dataStripeTransactions: "/data/stripe-transactions",
  dataTransactionDetails: "/data/transaction-:id",
  dataStripeTransactionDetails: "/data/stripe-transaction-:id",
  listReport: "/list-report/*",
  listSelection: "/list-selection",
  salesDashboard: "/sales-dashboard",
  vendorReport: "/vendor-report",
  profitLossReport: "/profit-loss-report",
  balanceSheetReport: "/balance-sheet-report",
  vendorAgingReport: "/vendor-aging-report",
  mailFiles: "/mail-files",
  customer: "/customer",
  customerDetail: "/customer-detail/:id",
  internalCustomerDetail: "/internal-customer/:id",
  accounting: "/accounting",
  invoices: "/accounting/invoices",
  createInvoice: "/accounting/create-invoice",
  createCredit: "/accounting/create-credit",
  credits: "/accounting/credits",
  invoiceItems: "/accounting/invoice-items",
  statements: "/accounting/statements",
  createStatement: "/accounting/create-statement",
  actionsHistory: "/accounting/actions-history",
  bankStatements: "/accounting/bank-statements",
  reports: "/accounting/reports",
  paymentAllocation: "/accounting/payment-allocation",
  accountingSettings: "/accounting/settings",

  // New Accounting Sub-modules
  accountingSalesDashboard: "/accounting/sales-dashboard",
  accountingReports: "/accounting/reports",
  accountsPayable: "/accounting/accounts-payable",
  accountsReceivable: "/accounting/accounts-receivable",
  advanceAccounting: "/accounting/advance-accounting",
  accountingSettingsNew: "/accounting/settings",
  mfVsPersons: "/mf-vs-persons",
  mfVsTimelineYears: "/mf-vs-timeline-years",
  mfVsTimelineMonths: "/mf-vs-timeline-months",
  mfVsList: "/mf-vs-list",
  validatorMarketingFile: "/validator-marketing-file",
  addproduct: "/add-product",
  brandlist: "/brand-list",
  units: "/units",
  variantyattributes: "/variant-attributes",
  warranty: "/warranty",
  barcode: "/barcode",
  alerts: "/ui-alerts",
  accordion: "/ui-accordion",
  avatar: "/ui-avatar",
  badges: "/ui-badges",
  borders: "/ui-borders",
  buttons: "ui-buttons",
  buttonsgroup: "/ui-buttons-group",
  breadcrumb: "/ui-breadcrumb",
  cards: "/ui-cards",
  dropdowns: "/ui-dropdowns",
  colors: "/ui-colors",
  carousel: "/ui-carousel",
  navtabs: "/ui-nav-tabs",
  grid: "/ui-grid",
  images: "/ui-images",
  lightbox: "/ui-lightbox",
  media: "/ui-media",
  modals: "/ui-modals",
  offcanvas: "/ui-offcanvas",
  pagination: "/ui-pagination",
  typography: "/ui-typography",
  tooltip: "/ui-tooltips",
  draganddrop: "/ui-drag-drop",
  departmentgrid: "/department-grid",
  departmentlist: "/department-list",
  designation: "/designation",
  shift: "/shift",
  attendanceemployee: "/attendance-employee",
  clipboard: "/ui-clipboard",
  popover: "/ui-popovers",
  tablebasic: "/tables-basic",
  datatable: "/data-tables",
  basicinput: "/form-basic-inputs",
  checkboxradio: "/form-checkbox-radios",
  inputgroup: "/form-input-groups",
  gridgutters: "/form-grid-gutters",
  formselect: "/form-select",
  fileupload: "/form-fileupload",
  formmask: "/form-mask",
  formhorizontal: "/form-horizontal",
  formvertical: "/form-vertical",
  floatinglabel: "/form-floating-labels",
  formvalidation: "/form-validation",
  select2: "/form-select2",

  toasts: "/ui-toasts",
  video: "/ui-video",
  sweetalerts: "/ui-sweetalerts",
  spinner: "/ui-spinner",
  progress: "/ui-progress",
  placeholder: "/ui-placeholders",
  rating: "/ui-rating",
  texteditor: "/ui-text-editor",
  counter: "/ui-counter",
  scrollbar: "/ui-scrollbar",
  stickynote: "/ui-stickynote",
  timeline: "/ui-timeline",
  apexchart: "/chart-apex",
  chartjs: "/chart-js",
  rangeslider: "/ui-rangeslider",
  fontawesome: "/icon-fontawesome",
  feathericon: "/icon-feather",
  ionicicons: "/icon-ionic",
  materialicons: "/icon-material",
  pe7icons: "/icon-pe7",
  simpleline: "/icon-simpleline",
  themifyicons: "/icon-themify",
  iconweather: "/icon-weather",
  typicons: "/icon-typicon",
  flagicons: "/icon-flag",
  ribbon: "/ui-ribbon",

  chat: "/chat",
  videocall: "/video-call",
  audiocall: "/audio-call",
  email: "/email",
  callhistory: "/call-history",
  todo: "/todo",
  wizard: "/form-wizard",
  expiredproduct: "/expired-products",
  lowstock: "/low-stocks",
  categorylist: "/category-list",
  subcategories: "/sub-categories",
  productdetails: "/product-details",
  editproduct: "/edit-product",
  expenselist: "/expense-list",
  expensecategory: "/expense-category",
  calendar: "/calendar",
  variantattributes: "/variant-attributes",
  qrcode: "/qrcode",
  purchaselist: "/purchase-list",
  purchaseorderreport: "/purchase-order-report",
  purchasereturn: "/purchase-returns",
  appearance: "/appearance",
  socialauthendication: "/social-authentication",
  languagesettings: "/language-settings",
  invoicesettings: "/invoice-settings",
  printersettings: "/printer-settings",
  possettings: "/pos-settings",
  customfields: "/custom-fields",
  emailsettings: "/email-settings",
  smssettings: "/sms-gateway",
  otpsettings: "/otp-settings",
  gdbrsettings: "/gdpr-settings",
  paymentgateway: "/payment-gateway-settings",
  banksettingslist: "/bank-settings-list",
  banksettingsgrid: "/bank-settings-grid",
  taxrates: "/tax-rates",
  storagesettings: "/storage-settings",
  banipaddress: "/ban-ip-address",
  generalsettings: "/general-settings",
  securitysettings: "/security-settings",
  notification: "/notification",
  actions: "/actions",
  connectedapps: "/connected-apps",
  systemsettings: "/system-settings",
  companysettings: "/company-settings",
  localizationsettings: "/localization-settings",
  prefixes: "/prefixes",
  preference: "/preference",
  saleslist: "/sales-list",
  invoicereport: "/invoice-report",
  salesreturn: "/sales-returns",
  quotationlist: "/quotation-list",
  pos: "/pos",
  attendanceadmin: "attendance-admin",
  payslip: "/payslip",
  holidays: "/holidays",
  customers: "/customers",
  suppliers: "/suppliers",
  storelist: "/store-list",
  managestock: "/manage-stocks",
  stockadjustment: "/stock-adjustment",
  stocktransfer: "/stock-transfer",
  salesreport: "/sales-report",
  purchasereport: "/purchase-report",
  inventoryreport: "/inventory-report",
  supplierreport: "/supplier-report",
  customerreport: "/customer-report",
  expensereport: "/expense-report",
  incomereport: "/income-report",
  taxreport: "/tax-report",
  profitloss: "/profit-loss-report",
  notes: "/notes",
  filemanager: "/file-manager",
  profile: "/profile",
  signin: "/signin",
  signintwo: "/signin-2",
  signinthree: "/signin-3",
  register: "/register",
  registerTwo: "/register-2",
  registerThree: "/register-3",
  forgotPassword: "/forgot-password",
  forgotPasswordTwo: "/forgot-password-2",
  forgotPasswordThree: "/forgot-password-3",
  resetpassword: "/reset-password",
  resetpasswordTwo: "/reset-password-2",
  resetpasswordThree: "/reset-password-3",
  emailverification: "/email-verification",
  emailverificationTwo: "/email-verification-2",
  emailverificationThree: "/email-verification-3",
  twostepverification: "/two-step-verification",
  twostepverificationTwo: "/two-step-verification-2",
  twostepverificationThree: "/two-step-verification-3",
  lockscreen: "/lock-screen",
  error404: "/error-404",
  error500: "/error-500",
  blankpage: "/blank-page",
  comingsoon: "/coming-soon",
  undermaintenance: "/under-maintenance",
  users: "/users",
  rolespermission: "/roles-permissions",
  permissions: "/permissions",
  deleteaccount: "/delete-account",
  employeegrid: "/employees-grid",
  addemployee: "/add-employee",
  editemployee: "/edit-employee",
  leavesadmin: "leaves-admin",
  leavesemployee: "/leaves-employee",
  leavestype: "/leave-types",
  warehouses: "/warehouse",
  coupons: "/coupons",
  payrollList: "/payroll-list",
  noPermissions: "/no-permissions",
  
  // PDF Parser
  pdfParser: "/pdf-parser",
  pdfParserUpload: "/pdf-parser/upload",
  pdfParserTemplates: "/pdf-parser/templates",
  pdfParserGenerate: "/pdf-parser/generate",
  pdfParserHistory: "/pdf-parser/history",
  pdfParserFonts: "/pdf-parser/fonts",
};

// To redirect the user to first page he can access in tab order
export const orderOfPage = {
  "/products/list": 0,
  "/products/variation-status": 1,
  "/products/orders": 2,
  "/products/orders-summary": 3,
  "/products/delivery-summary": 4,
  "/products/stock-evolution": 5,
  "/products/stocks": 6,

  // Dynamic pages give it large number to keep them last options
  "/products/create": Number.POSITIVE_INFINITY,
  "/products/edit": Number.POSITIVE_INFINITY,
  "/products/view": Number.POSITIVE_INFINITY,

  // Even if the same numbers but different base page
  "/marketing/offers": 1,
  "/marketing/skus": 2,
  "/marketing/edit-marketing": 3,
  "/marketing/envelopes": 4,
  "/marketing/phone-numbers": 5,
  "/marketing/file-validator": 6,
  "/marketing/marketing-priority": 7,
  "/marketing/marketing-cost-breakdown": 8, // When added check the number

  "/order-list/product-orders": 1,
  "/order-list/print-orders": 2,
  "/order-list/list-orders": 3,
  "/order-list/suppliers": 4,
  "/order-list/warehouses": 5,

  "/media-plans/campaigns": 1,
  "/media-plans/purchase-order-evolution": 2,
  "/media-plans/ror-100-days": 3,
  "/media-plans/lists": 4,
  "/media-plans/view-media-plan": 5,

  // Can be deleted as they doesn't have subpages
  "/costs": 0,
  "/estimated-cash-flow": 0,
  "/mailing-report": 0,
  "/list-report": 0,
  "/mailing-response-ltv-data": 0,
  "/list-selection": 0,
  "/sales-dashboard": 0,
  "/customer-reports": 0,
  "/sales-by-date": 0,
  "/vendor-report": 0,
  "/profit-loss-report": 0,
  "/balance-sheet-report": 0,
  "/vendor-aging-report": 0,
  "/sales-dump-analysis": 0,
  "/sales-dump-data": 0,
  "/mail-files": 0,
  "/mf-vs-persons": 0,
  "/mf-vs-list": 0,
  "/mf-vs-timeline-years": 0,
  "/mf-vs-timeline-months": 0,
  "/customer": 0,
  "/data": 0,
  "/clients": 0,
  "/access-control": 0,
  "/login-history": 0,

  "/accounting/create-invoice": 1,
  "/accounting/payment-allocation": 2,
  "/accounting/reports": 3,
  "/accounting/settings": 4,
  "/accounting/actions-history": 5,
  "/accounting/aging-report": 6,
  "/accounting/aspire": 7,
  "/accounting/invoices": 8,
  "/accounting/dashboard": 9,
  "/accounting/reports-list": 10,
  "/accounting/financial-reports": 11,
  "/accounting/transactions-allocations": 12,
  "/accounting/letter-processing-records": 13,

  // New Accounting Sub-modules order
  "/accounting/sales-dashboard": 0,
  "/accounting/accounts-payable": 1,
  "/accounting/accounts-receivable": 2,
  "/accounting/advance-accounting": 3,
  
  // PDF Parser
  "/pdf-parser": 0,
  "/pdf-parser/upload": 1,
  "/pdf-parser/templates": 2,
  "/pdf-parser/generate": 3,
  "/pdf-parser/history": 4,
  "/pdf-parser/fonts": 5,
};
